import {
  FontAwesomeIcon,
  GrcTextBox,
  GrcTooltip,
  GrcTooltipPosition,
  IconProp,
  facircleinfoclassicregular
} from '@grc/ui-package';
import { formatDate } from '@grc/ui-utility';
import { useI18nState } from '../../../stores/settings/language-context';
import DateRangeFilter from '../../../common/date-range-filter/date-range-filter';
import { IDateRangeFilterValue } from '../../../common/date-range-filter/date-range-filter.interface';
import './shipment-toolbar.scss';

interface IShipmentToolbarProps {
  searchText: string;
  onSearchTextChange: (value: string) => void;
  dateFilter: IDateRangeFilterValue;
  onDateFilterChange: (value: IDateRangeFilterValue) => void;
}

export default function ShipmentToolbar({
  searchText,
  onSearchTextChange,
  dateFilter,
  onDateFilterChange
}: IShipmentToolbarProps) {
  const { localeData } = useI18nState();
  const { fromDate, toDate } = dateFilter;

  const dateRangeLabel =
    fromDate.toDateString() === toDate.toDateString()
      ? formatDate(fromDate)
      : `${formatDate(fromDate)} - ${formatDate(toDate)}`;

  return (
    <div className="shipment-toolbar" data-testid="shipment_toolbar">
      <div className="shipment-toolbar-search position-relative">
        <GrcTextBox
          placeholder={localeData.SearchByShipmentId}
          value={searchText}
          mode="search"
          onValueChange={(e: any) => onSearchTextChange(e ?? '')}
        />
      </div>

      <span className="shipment-toolbar-date-label">{dateRangeLabel}</span>

      <div className="shipment-toolbar-right d-flex align-items-center">
        <DateRangeFilter
          idPrefix="shipments"
          value={dateFilter}
          onChange={onDateFilterChange}
        />
        <GrcTooltip
          title={localeData.ShipmentsInfoTooltip}
          position={GrcTooltipPosition.Top}
        >
          <span
            className="shipment-toolbar-info ms-2"
            role="img"
            aria-label={localeData.ShipmentsInfoTooltip}
          >
            <FontAwesomeIcon icon={facircleinfoclassicregular as IconProp} />
          </span>
        </GrcTooltip>
      </div>
    </div>
  );
}
